import { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { getAbbreviation } from "../../../core/common/common_functions";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { company_short_name } from "../../../environment";
import api from "../../../services/api";
import Loader from "../../../core/common/loader";
import { FaArrowUp, FaArrowDown } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { useSelector } from "react-redux";
import CommonSelect from "../../../core/common/commonSelect";
import PredefinedDateRanges from "../../../core/common/datePicker";

import {
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  IconButton,
  InputLabel,
  Chip,
  OutlinedInput,
  FormControlLabel,
  Checkbox,
} from "@mui/material";

const CMSDasboard = () => {
  const user = useSelector((state: any) => state.user.user);
  const navigate = useNavigate();
  const signature = localStorage.getItem("signature");
  const routes = all_routes;
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingPipeline, setIsLoadingPipeline] = useState(false);
  const [isHoveredTotalLead, setisHoveredTotalLead] = useState(false);
  const [isHoveredTodayLead, setIsHoveredTodayLead] = useState(false);
  const [isHoveredFollowUp, setisHoveredFollowUp] = useState(false);
  const [isHoveredTodoReminder, setisHoveredTodoReminder] = useState(false);
  const [companyList, setCompanyList] = useState<any[]>([]);
  const [leadFormList, setLeadForms] = useState<any[]>([]);
  const [filteredDataPipeline, setfilteredDataPipeline] = useState<any[]>([]);
  const [getDashboardDetails, setgetDashboardDetails] = useState<
    Record<string, any>
  >({});
  const [revenueIncome, setRevenueIncome] = useState<any>(null);
  const [leadData, setleadData] = useState<any[]>([]);
  var initialFormDataChooseCompany = {
    signature: signature,
    companyName: "Select Company",
    companyId: "",
    companyType: "CMS",
    employee_id: "",
    employee_name: "",
    form_id: "",
    form_name: "",
    start_date: moment().startOf("month"),
    end_date: moment(),
  };
  const [formDataCompanyChoose, setformDataCompanyChoose] = useState(
    initialFormDataChooseCompany
  );

  const [LeadEmployeesList, setLeadEmployeesList] = useState<any[]>([]);

  interface HeatmapDataPoint {
    x: string;
    y: number;
    color?: string;
  }

  interface HeatmapSeries {
    name: string;
    data: HeatmapDataPoint[];
  }

  const [heatChart, setHeatChart] = useState<{
    series: HeatmapSeries[];
    options: ApexOptions;
  }>({
    series: [],
    options: {},
  });

  const updateUI = async () => {
    if (
      formDataCompanyChoose.companyId != "" &&
      formDataCompanyChoose.companyName != "Select Company" &&
      formDataCompanyChoose.form_id != ""
    ) {
      setIsLoading(true);
      const [LeadDashboard, getAllLeadsResponse] = await Promise.all([
        api.post("leadService/cmsDealDashboard", {
          signature,
          company_id: formDataCompanyChoose.companyId,
          company_type: formDataCompanyChoose.companyType,
          employee_id: parseInt(formDataCompanyChoose.employee_id),
          form_id: formDataCompanyChoose.form_id,
          start_date: formDataCompanyChoose.start_date,
          end_date: formDataCompanyChoose.end_date,
        }),
        api.post("leadService/getAllLeadsResponseCMSDashboard", {
          signature,
          company_id: formDataCompanyChoose.companyId,
          company_type: formDataCompanyChoose.companyType,
          employee_id: parseInt(formDataCompanyChoose.employee_id),
          form_id: formDataCompanyChoose.form_id,
          start_date: formDataCompanyChoose.start_date,
          end_date: formDataCompanyChoose.end_date,
          type: "deal",
        }),
      ]);

      const top5leads = getAllLeadsResponse.data.data.data?.slice(0, 5);
      setleadData(top5leads);
      setgetDashboardDetails(LeadDashboard.data.data.data);
      newLeadData(LeadDashboard.data.data.data.sixweekleads);
      setSelectedForm(LeadDashboard.data.data.data?.leadStages[0]?.name);

      setIsLoading(false);
    }
  };

  useEffect(() => {
    const getCompanyList = async () => {
      try {
        const [companyList] = await Promise.all([
          api.post("userService/getAllCompanyList", {
            signature,
          }),
        ]);

        setCompanyList(companyList.data.data.data);
      } catch (err) {
        console.error("Error fetching dashboard data:", err);
      }
    };
    getCompanyList();
  }, []);

  const companyChoose = [
    ...companyList?.map((company: any) => ({
      value: company.id,
      label: company.name + " - " + company.type,
    })),
  ];

  const formChoose = [
    ...leadFormList?.map((form: any) => ({
      value: form.key,
      label: form.LeadFormName,
    })),
  ];

  const handleCompanyChanges = async (selectedOption: any) => {
    if (selectedOption.value == undefined) return;
    const newFormData = {
      companyId: selectedOption.value,
      companyName: selectedOption.label.split("-")[0].trim(),
      companyType: selectedOption.label.split("-")[1].trim(),
    };

    setformDataCompanyChoose((prev: any) => ({
      ...prev,
      ...newFormData,
    }));

    const [getLeadSettings] = await Promise.all([
      api.post("leadService/getAllLeadSettings", {
        signature,
        company_id: parseInt(newFormData.companyId),
        company_type: newFormData.companyType,
      }),
    ]);
    if (getLeadSettings.data.data.data.length > 0) {
      const [getAllEmployeList, getAllLeadFormsByCompany] = await Promise.all([
        api.post("userService/getLeadEmployeesListData", {
          signature,
          department:
            getLeadSettings?.data?.data?.data[0]?.settings
              ?.lead_assigned_to_department || -1,
          company_id: parseInt(newFormData.companyId),
          company_type: newFormData.companyType,
        }),
        api.post("leadService/getLeadFormsByCompany", {
          signature,
          company_id: parseInt(newFormData.companyId),
          company_type: newFormData.companyType,
        }),
      ]);
      setLeadEmployeesList(getAllEmployeList.data.data.data.allUsers);
      setLeadForms(getAllLeadFormsByCompany.data.data.data);
    } else {
      setLeadEmployeesList([]);
    }
  };

  const employeesList = [
    { value: "0", label: "All Employees" },
    ...LeadEmployeesList.map((empolyee: any) => ({
      value: empolyee.key,
      label: empolyee.Name,
    })),
  ];

  const handleEmployeeChange = (selectedOption: any) => {
    if (selectedOption.value == undefined) return;
    const newFormData = {
      employee_id: selectedOption.value,
      employee_name: selectedOption.label,
    };

    setformDataCompanyChoose((prev: any) => ({
      ...prev,
      ...newFormData,
    }));
  };

  const handleFormChange = (selectedOption: any) => {
    if (selectedOption.value == undefined) return;
    const newFormData = {
      form_id: selectedOption.value,
      form_name: selectedOption.label,
    };

    setformDataCompanyChoose((prev: any) => ({
      ...prev,
      ...newFormData,
    }));
  };
  useEffect(() => {
    handleCompanyChanges({
      value: companyList?.[0]?.id,
      label: companyList?.[0]?.name + "-" + companyList?.[0]?.type,
    });
  }, [companyList]);

  useEffect(() => {
    handleEmployeeChange({
      value: employeesList?.[0]?.value,
      label: employeesList?.[0]?.label,
    });
  }, [LeadEmployeesList]);

  useEffect(() => {
    handleFormChange({
      value: leadFormList?.[0]?.key,
      label: leadFormList?.[0]?.LeadFormName,
    });
  }, [leadFormList]);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        await updateUI();
      } catch (err) {
        console.error("Error fetching dashboard data:", err);
      }
    };
    fetchDashboardData();
  }, [formDataCompanyChoose]);

  const handleDateChange = (start: moment.Moment, end: moment.Moment) => {
    var newFormData = {
      start_date: start.format("YYYY-MM-DD"),
      end_date: end.format("YYYY-MM-DD"),
    };

    setformDataCompanyChoose((prev: any) => ({
      ...prev,
      ...newFormData,
    }));
  };

  //Calls Records Start
  const monthNames = [];
  for (let month = 0; month < 12; month++) {
    const date = new Date(2000, month); // year doesn't matter, just using to get month name
    monthNames.push(date.toLocaleString("default", { month: "long" }));
  }

  // Lead By stages Start
  const formNames: string[] = Array.from(
    new Set(
      getDashboardDetails?.leadStages?.map((company: any) => company.name) || []
    )
  );
  const filteredData =
    getDashboardDetails?.leadStages?.find(
      (company: any) => company.name === formDataCompanyChoose.form_name
    )?.stages_data || [];

  const chartData: ApexOptions = useMemo(() => {
    const series: number[] =
      filteredData?.map((stage: any) => stage.stage_count) ?? [];
    const labels = filteredData?.map((stage: any) => stage.pipeline_char) ?? [];
    const totalCount = series.reduce(
      (sum: any, val: any) => parseInt(sum) + parseInt(val),
      0
    );
    return {
      series, // Now explicitly a number array
      chart: {
        type: "donut",
        height: 185,
        events: {
          dataPointSelection: async (
            event: any,
            chartContext: any,
            config: any
          ) => {
            const selectedLabel =
              chartData.labels?.[config.dataPointIndex] ?? "Unknown";

            navigate(routes.leadsList, {
              state: {
                selectedLabel: selectedLabel,
                type: "stage",
              },
            });
          },
        },
      },
      labels,
      colors: ["#FFC107", "#0C4B5E", "#AB47BC", "#FD3995"], // Colors from the image
      plotOptions: {
        pie: {
          donut: {
            size: "60%",
            labels: {
              show: true,
              total: {
                show: true,
                label: "Leads",
                formatter: () => `${totalCount}`,
              },
            },
          },
        },
      },
      stroke: {
        lineCap: "round",
        show: true,
        width: 0, // Space between donut sections
        colors: ["#fff"],
      },
      legend: {
        show: false,
      },
      dataLabels: {
        enabled: false,
      },
    };
  }, [filteredData]);

  const [showAllStages, setShowAllStages] = useState(false);

  const visibleLeadsStages = showAllStages
    ? filteredData
    : filteredData.slice(0, 3);
  // Lead By stages End

  //Lead by Source Start
  const chartData2: ApexOptions = useMemo(() => {
    const series: number[] =
      getDashboardDetails?.leadSources?.map((lead: any) =>
        parseInt(lead.count)
      ) ?? [];
    const labels =
      getDashboardDetails?.leadSources?.map(
        (lead: any) => lead.lead_source_child
      ) ?? [];
    return {
      series,
      chart: {
        type: "donut",
        height: 185,
        events: {
          dataPointSelection: async (
            event: any,
            chartContext: any,
            config: any
          ) => {
            const selectedLabel =
              chartData2.labels?.[config.dataPointIndex] ?? "Unknown";
            try {
              navigate(routes.leadsList, {
                state: {
                  selectedLabel: selectedLabel,
                  type: "source",
                },
              });
            } catch (err) {
              console.error("Error fetching dashboard data:", err);
            }
          },
        },
      },
      labels,
      colors: ["#FFC107", "#0C4B5E", "#AB47BC", "#FD3995"],
      plotOptions: {
        pie: {
          donut: {
            size: "60%",
            labels: {
              show: true,
              total: {
                show: true,
                label: "Sources",
                formatter: () => `${leadSources.length}`,
              },
            },
          },
        },
      },
      stroke: {
        lineCap: "round",
        show: true,
        width: 0,
        colors: ["#fff"],
      },
      legend: {
        show: false,
      },
      dataLabels: {
        enabled: false,
      },
    };
  }, [getDashboardDetails?.leadSources]);

  const [showAllSources, setShowAllSources] = useState(false);
  const leadSources = getDashboardDetails?.leadSources || [];
  const total =
    (chartData2.series as number[])?.reduce((a, b) => a + b, 0) || 1;
  const visibleLeads = showAllSources ? leadSources : leadSources.slice(0, 3);

  //Lead by Source End

  //Pipeline Stages start
  const [selectedYear, setSelectedYear] = useState(
    new Date().getFullYear().toString()
  );
  const currentYear = new Date().getFullYear();
  const startYear = 2018;
  const yearRanges = [];

  for (let year = currentYear; year >= startYear; year--) {
    yearRanges.push(`${year}`);
  }

  useEffect(() => {
    if (formDataCompanyChoose.form_name == "" || !selectedYear) return;
    const PipelineStages = async () => {
      try {
        setIsLoadingPipeline(true);
        const [data] = await Promise.all([
          api.post("leadService/leadCmsDashboardPipeline", {
            signature,
            form_name: formDataCompanyChoose.form_name,
            year: selectedYear.trim(),
            employee_id: parseInt(formDataCompanyChoose.employee_id),
            type: "deal",
          }),
        ]);

        const pipeline = data.data.data.data.leadStagePipeline;
        const monthNames = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        const stageMap: { [stage: string]: number[] } = {};

        if (pipeline.length > 0) {
          setfilteredDataPipeline(
            getDashboardDetails?.leadStages?.find(
              (company: any) => company.name === formDataCompanyChoose.form_name
            )?.stages_data || []
          );
        } else {
          setfilteredDataPipeline([]);
        }

        pipeline.forEach((item: any) => {
          const monthIndex = parseInt(item.month) - 1;
          const stage = item.pipeline_char;
          const count = parseInt(item.total);

          if (!stageMap[stage]) {
            stageMap[stage] = Array(12).fill(0);
          }

          stageMap[stage][monthIndex] += count;
        });

        const series = Object.keys(stageMap).map((stage) => ({
          name: stage,
          data: stageMap[stage],
        }));

        // Update chart config
        setRevenueIncome({
          chart: {
            height: 230,
            type: "bar",
            stacked: true,
            toolbar: {
              show: false,
            },
            events: {
              dataPointSelection: async (
                event: any,
                chartContext: any,
                config: any
              ) => {
                const clickedIndex = config.dataPointIndex;
                const seriesIndex = config.seriesIndex;
                const label =
                  config.w.config.xaxis.categories?.[clickedIndex] ?? "Unknown";
                const series = config.w.config.series;
                const value = series?.[seriesIndex]?.data?.[clickedIndex] ?? 0;
                const seriesName =
                  series?.[seriesIndex]?.name ?? "Unnamed Series";

                const year = parseInt(selectedYear, 10);

                // 🗓 Convert label (e.g. 'March') to date range
                const monthIndex = new Date(`${label} 1, ${year}`).getMonth(); // 0-based
                const startDate = new Date(year, monthIndex, 1);
                const endDate = new Date(year, monthIndex + 1, 0); // last day of the month

                const formatDate = (date: Date) =>
                  date.toISOString().split("T")[0];
                const formattedStart = formatDate(startDate);
                const formattedEnd = formatDate(endDate);

                try {
                  navigate(routes.leadsList, {
                    state: {
                      selectedLabel:
                        seriesName + "," + formattedStart + "," + formattedEnd,
                      type: "pipeline_stage",
                    },
                  });
                } catch (err) {
                  console.error("Error fetching dashboard data:", err);
                }
              },
            },
          },
          colors: ["#FF6F28", "#6F42C1", "#20C997"], // Add more if needed
          responsive: [
            {
              breakpoint: 480,
              options: {
                legend: {
                  position: "bottom",
                  offsetX: -10,
                  offsetY: 0,
                },
              },
            },
          ],
          plotOptions: {
            bar: {
              borderRadius: 5,
              borderRadiusWhenStacked: "all",
              horizontal: false,
              endingShape: "rounded",
            },
          },
          series,
          xaxis: {
            categories: monthNames,
            labels: {
              style: {
                colors: "#6B7280",
                fontSize: "13px",
              },
            },
          },
          yaxis: {
            show: false,
            min: 0,
            labels: {
              offsetX: -15,
              style: {
                colors: "#6B7280",
                fontSize: "13px",
              },
              formatter: function (value: string) {
                return value + "K";
              },
            },
          },
          grid: {
            borderColor: "transparent",
            strokeDashArray: 5,
            padding: {
              left: -8,
            },
          },
          legend: {
            show: true,
          },
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            y: {
              formatter: function (val: number) {
                return val + " Leads";
              },
            },
          },
          fill: {
            opacity: 1,
          },
        });
        setIsLoadingPipeline(false);
      } catch (err) {
        console.error("Error fetching dashboard data:", err);
      }
    };

    PipelineStages();
  }, [selectedYear, formDataCompanyChoose.form_name]);

  const MAX_VISIBLE_CARDS = 6;

  const visibleStages = showAllStages
    ? filteredDataPipeline
    : filteredDataPipeline?.slice(0, MAX_VISIBLE_CARDS);

  //Pipeline Stages End

  //New Lead Start
  const newLeadData = async (data: any) => {
    const weekdays = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

    // 1. Group data by week
    const grouped: any = {};
    data.forEach(({ week, day, count }: any) => {
      if (!grouped[week]) {
        grouped[week] = weekdays.map((d) => ({ x: d, y: 0 }));
      }
      const dayEntry = grouped[week].find((d: any) => d.x === day);
      if (dayEntry) dayEntry.y = count;
    });

    // 2. Find top 5 highest values
    const allPoints = Object.values(grouped).flat();
    const sorted = [...allPoints].sort((a: any, b: any) => b.y - a.y);
    const top5 = sorted.slice(0, 5);

    // 3. Add custom color to top 5
    const heatmapSeries = Object.entries(grouped).map(([week, data]: any) => ({
      name: week,
      data: data.map((point: any) => {
        const isTop = top5.some(
          (top: any) => top.x === point.x && top.y === point.y
        );
        return isTop
          ? { ...point, color: "#F37438" } // orange highlight
          : point;
      }),
    }));

    // 4. Set chart config
    setHeatChart({
      series: heatmapSeries,
      options: {
        chart: {
          type: "heatmap",
          height: 300,
        },
        colors: ["#000000"],
        dataLabels: {
          enabled: true,
        },
        xaxis: {
          type: "category",
        },
      },
    });
  };
  //New Lead End

  //Today Follow Up Start
  const [checkedIdsFollowup, setCheckedIdsFollowup] = useState<number[]>([]);
  const [visibleFollowUps, setVisibleFollowUps] = useState<any[]>([]);
  const [visibleFollowUpsAll, setVisibleFollowUpsAll] = useState<any[]>([]);

  useEffect(() => {
    if (getDashboardDetails?.total_follow_up_list_today) {
      const initial = getDashboardDetails?.total_follow_up_list_today?.slice(
        0,
        5
      );
      setVisibleFollowUps(initial);

      const initialAll = getDashboardDetails?.total_follow_up_list_today;
      setVisibleFollowUpsAll(initialAll);
    }
  }, [getDashboardDetails]);

  //Pending Follow Up Start
  const [checkedIdsPending, setCheckedIdsPending] = useState<number[]>([]);
  const [visibleFollowUpsPending, setVisibleFollowUpsPending] = useState<any[]>(
    []
  );
  const [visibleFollowUpsPendingAll, setVisibleFollowUpsPendingAll] = useState<
    any[]
  >([]);

  useEffect(() => {
    if (getDashboardDetails?.total_follow_up_pending_list) {
      const initial = getDashboardDetails?.total_follow_up_pending_list?.slice(
        0,
        5
      );
      setVisibleFollowUpsPending(initial);

      const initialAll = getDashboardDetails?.total_follow_up_pending_list;
      setVisibleFollowUpsPendingAll(initialAll);
    }
  }, [getDashboardDetails]);

  //Pending Follow Up end

  //Totoal Follow Up Start
  const [visibleFollowUpsTotal, setVisibleFollowUpsTotal] = useState<any[]>([]);

  useEffect(() => {
    if (getDashboardDetails?.total_follow_up_pending_list) {
      const initialAll = getDashboardDetails?.total_follow_up_list;
      setVisibleFollowUpsTotal(initialAll);
    }
  }, [getDashboardDetails]);
  //Total Follow Up end

  //Recent Activites Start
  const [visibleRecentActivity, setvisibleRecentActivity] = useState<any[]>([]);
  const [visibleRecentActivityAll, setvisibleRecentActivityAll] = useState<
    any[]
  >([]);
  useEffect(() => {
    if (getDashboardDetails?.recentActivities) {
      const initial = getDashboardDetails?.recentActivities?.slice(0, 5);
      setvisibleRecentActivity(initial);

      const initialAll = getDashboardDetails?.recentActivities;
      setvisibleRecentActivityAll(initialAll);
    }
  }, [getDashboardDetails]);
  //Recent Activites End

  //Data Sort As per Form Label Start
  const [selectedForm, setSelectedForm] = useState(null);
  const [formFields, setFormFields] = useState([]);
  const [selectedField, setSelectedField] = useState(null);
  const [columnBasedData, setcolumnBasedData] = useState<any[]>([]);

  useEffect(() => {
    if (!selectedForm) return;
    const FormFieldsData = async () => {
      try {
        const [formFieldsData] = await Promise.all([
          api.post("leadService/formFiledData", {
            signature,
            form_name: selectedForm,
          }),
        ]);
        let filteredFields = formFieldsData.data.data.data.structure.filter(
          (field: any) =>
            !["Full Name", "Email", "Mobile No", "Location"].includes(
              field.label
            )
        );

        // Check if "Location" exists in the original fields
        const hasLocation = formFieldsData.data.data.data.structure.some(
          (field: any) => field.label === "Location"
        );

        // If "Location" was present, add "Country", "State", and "City"
        if (hasLocation) {
          filteredFields.push(
            { label: "Country" },
            { label: "State" },
            { label: "City" }
          );
        }

        setFormFields(filteredFields);
      } catch (err) {
        console.error("Error fetching dashboard data:", err);
      }
    };

    FormFieldsData();
  }, [selectedForm]);

  const handleFieldChange = async (e: any) => {
    const fieldLabel = e.target.value;
    setSelectedField(fieldLabel);

    try {
      const [formFieldsData] = await Promise.all([
        api.post("leadService/getCMSDataAsPerColumn", {
          signature,
          form_name: selectedForm,
          column: fieldLabel,
          employee_id: parseInt(formDataCompanyChoose.employee_id),
          start_date: formDataCompanyChoose.start_date,
          end_date: formDataCompanyChoose.end_date,
          type: "deal",
        }),
      ]);
      setcolumnBasedData(formFieldsData.data.data.data);
    } catch (err) {
      console.error("Error calling field API:", err);
    }
  };

  return (
    <>
      {isLoading && <Loader />}
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">CMS Dashboard</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.leadsDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Dashboard</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    CMS Dashboard
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="dropdown me-2 mb-2">
                <div className="input-icon-end position-relative">
                  <PredefinedDateRanges onDateChange={handleDateChange} />
                  <span className="input-icon-addon">
                    <i className="ti ti-chevron-down" />
                  </span>
                </div>
              </div>

              <div className="dropdown me-2 mb-2">
                <CommonSelect
                  className="select"
                  options={formChoose}
                  defaultValue={{
                    value: formDataCompanyChoose.form_id,
                    label: formDataCompanyChoose.form_name,
                  }}
                  onChange={handleFormChange}
                />
              </div>

              <div className="dropdown me-2 mb-2">
                <CommonSelect
                  className="select"
                  options={employeesList}
                  defaultValue={{
                    value: formDataCompanyChoose.employee_id,
                    label: formDataCompanyChoose.employee_name,
                  }}
                  onChange={handleEmployeeChange}
                />
              </div>

              <div className="dropdown me-2 mb-2">
                <CommonSelect
                  className="select"
                  options={companyChoose}
                  defaultValue={{
                    value: formDataCompanyChoose.companyId,
                    label:
                      formDataCompanyChoose.companyName +
                      "-" +
                      formDataCompanyChoose.companyType,
                  }}
                  onChange={handleCompanyChanges}
                />
              </div>

              <div className="ms-2 head-icons">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}

          <div className="card border-0">
            <div className="card-body d-flex align-items-center justify-content-between flex-wrap pb-1">
              <div className="d-flex align-items-center mb-3">
                <span className="avatar avatar-xl flex-shrink-0">
                  <ImageWithBasePath
                    src="assets/img/profiles/avatar-31.jpg"
                    className="rounded-circle"
                    alt="img"
                  />
                </span>
                <div className="ms-3">
                  <h3 className="mb-2">
                    Welcome Back, {user?.userDetails.fname}{" "}
                  </h3>
                  <p>
                    You have{" "}
                    <span className="text-primary text-decoration-underline">
                      0
                    </span>{" "}
                    Reminders &amp;{" "}
                    <span className="text-primary text-decoration-underline">
                      0
                    </span>{" "}
                    To-Do
                  </p>
                </div>
              </div>
              <div className="d-flex align-items-center flex-wrap mb-1">
                <div className="d-flex align-items-center gap-2 mb-2 me-2">
                  {/* 🔁 Toggle Button */}
                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    onClick={() => navigate(routes.cmsLeadDashboard)}
                    style={{ textTransform: "none" }}
                  >
                    Switch to Lead
                  </Button>
                </div>

                <Link
                  to="#"
                  className="btn btn-secondary btn-md me-2 mb-2"
                  data-bs-toggle="modal"
                  data-inert={true}
                  data-bs-target="#"
                >
                  <i className="ti ti-square-rounded-plus me-1" />
                  Add To-Do
                </Link>
                <Link
                  to="#"
                  className="btn btn-primary btn-md mb-2"
                  data-bs-toggle="modal"
                  data-inert={true}
                  data-bs-target="#"
                >
                  <i className="ti ti-square-rounded-plus me-1" />
                  Add Reminder
                </Link>
              </div>
            </div>
          </div>

          {/* First Section */}
          <div className="row mb-3">
            <div className="col-xl-3 col-md-6">
              <div
                className="position-relative"
                onMouseEnter={() => setisHoveredTotalLead(true)}
                onMouseLeave={() => setisHoveredTotalLead(false)}
              >
                <div
                  className="d-flex align-items-center p-3 rounded-4 shadow-sm bg-white hover-shadow-lg transition"
                  style={{
                    border: "1px solid #e0e0e0",
                    cursor: "pointer",
                  }}
                >
                  <div
                    className="icon-wrapper bg-gradient-primary text-white d-flex align-items-center justify-content-center rounded-circle"
                    style={{
                      width: "48px",
                      height: "48px",
                      background: "linear-gradient(135deg, #4e73df, #1cc88a)",
                      fontSize: "20px",
                    }}
                  >
                    <i className="ti ti-users"></i>
                  </div>

                  <div className="ms-3">
                    <p
                      className="fw-semibold text-secondary mb-1"
                      style={{ fontSize: "14px" }}
                    >
                      Total Number of Deals
                    </p>
                    <Link
                      to={routes.leadsList}
                      state={{ totalLeads: getDashboardDetails?.totalLeads }}
                      className="text-decoration-none"
                      style={{ display: "inline-flex", alignItems: "center" }}
                    >
                      <h4 className="text-dark mb-0 me-2">
                        {getDashboardDetails?.totalLeads}
                      </h4>
                      <i className="ti ti-chevron-right text-muted"></i>
                    </Link>
                  </div>
                </div>

                {/* Hover Content */}
                {isHoveredTotalLead && (
                  <div
                    style={{
                      background: "#F8F9FA",
                      padding: "10px",
                      borderRadius: "8px",
                      marginTop: "10px",
                      transition: "opacity 0.3s ease-in-out",
                    }}
                  >
                    <div className="d-flex justify-content-between">
                      <p className="fw-medium fs-14 mb-0 text-secondary">
                        Last Week:
                      </p>
                      <span className="fs-14 text-danger fw-bold">
                        {getDashboardDetails?.weekStats?.lastWeekLeads}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between mt-2">
                      <p className="fw-medium fs-14 mb-0 text-secondary">
                        This Week:
                      </p>
                      <span className="fs-14 text-primary fw-bold">
                        {getDashboardDetails?.weekStats?.thisWeekLeads}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between mt-2">
                      <p className="fw-medium fs-14 mb-0 text-secondary">
                        Difference:
                      </p>
                      <span
                        className={`fs-14 fw-bold ${
                          getDashboardDetails?.weekStats?.weekDifference > 0
                            ? "text-success"
                            : "text-danger"
                        }`}
                      >
                        {getDashboardDetails?.weekStats?.weekDifference > 0 ? (
                          <FaArrowUp style={{ color: "green" }} />
                        ) : (
                          <FaArrowDown />
                        )}{" "}
                        {getDashboardDetails?.weekStats?.weekDifference}
                        {" %"}
                      </span>
                    </div>
                  </div>
                )}

                <span className="position-absolute top-0 end-0">
                  <img
                    src="assets/img/bg/card-bg-04.png"
                    alt="Img"
                    style={{ width: "50px", opacity: "0.3" }}
                  />
                </span>
              </div>
            </div>

            <div className="col-xl-3 col-md-6">
              <div
                className="position-relative"
                onMouseEnter={() => setIsHoveredTodayLead(true)}
                onMouseLeave={() => setIsHoveredTodayLead(false)}
              >
                <div
                  className="d-flex align-items-center p-3 rounded-4 shadow-sm bg-white hover-shadow-lg transition"
                  style={{
                    border: "1px solid #e0e0e0",
                    cursor: "pointer",
                  }}
                >
                  <div
                    className="icon-wrapper bg-gradient-primary text-white d-flex align-items-center justify-content-center rounded-circle"
                    style={{
                      width: "48px",
                      height: "48px",
                      background: "linear-gradient(135deg, #36b9cc, #1cc88a)",
                      fontSize: "20px",
                    }}
                  >
                    <i className="ti ti-delta"></i>
                  </div>

                  <div className="ms-3">
                    <p
                      className="fw-semibold text-secondary mb-1"
                      style={{ fontSize: "14px" }}
                    >
                      Today's Deals
                    </p>
                    <Link
                      to={routes.leadsList}
                      state={{
                        todayLeads: getDashboardDetails?.todayStats?.todayLeads,
                      }}
                      className="text-decoration-none"
                      style={{ display: "inline-flex", alignItems: "center" }}
                    >
                      <h4 className="text-dark mb-0 me-2">
                        {getDashboardDetails?.todayStats?.todayLeads}
                      </h4>
                      <i className="ti ti-chevron-right text-muted"></i>
                    </Link>
                  </div>
                </div>

                {/* Hover Content */}
                {isHoveredTodayLead && (
                  <div
                    style={{
                      background: "#F8F9FA",
                      padding: "10px",
                      borderRadius: "8px",
                      marginTop: "10px",
                      transition: "opacity 0.3s ease-in-out",
                    }}
                  >
                    <div className="d-flex justify-content-between">
                      <p className="fw-medium fs-14 mb-0 text-secondary">
                        Last Week Same Day:
                      </p>
                      <span className="fs-14 text-danger fw-bold">
                        {getDashboardDetails?.todayStats?.lastWeekSameDayLeads}
                      </span>
                    </div>

                    <div className="d-flex justify-content-between mt-2">
                      <p className="fw-medium fs-14 mb-0 text-secondary">
                        Difference:
                      </p>
                      <span
                        className={`fs-14 fw-bold ${
                          getDashboardDetails?.todayStats?.todayDifference > 0
                            ? "text-success"
                            : "text-danger"
                        }`}
                      >
                        {getDashboardDetails?.todayStats?.todayDifference >
                        0 ? (
                          <FaArrowUp style={{ color: "green" }} />
                        ) : (
                          <FaArrowDown />
                        )}{" "}
                        {getDashboardDetails?.todayStats?.todayDifference} %
                      </span>
                    </div>
                  </div>
                )}

                <span className="position-absolute top-0 end-0">
                  <img
                    src="assets/img/bg/card-bg-04.png"
                    alt="Img"
                    style={{ width: "50px", opacity: "0.3" }}
                  />
                </span>
              </div>
            </div>

            <div className="col-xl-3 col-md-6">
              <div
                className="position-relative"
                onMouseEnter={() => setisHoveredFollowUp(true)}
                onMouseLeave={() => setisHoveredFollowUp(false)}
              >
                <div
                  className="d-flex align-items-center p-3 rounded-4 shadow-sm bg-white hover-shadow-lg transition"
                  style={{
                    border: "1px solid #e0e0e0",
                    cursor: "pointer",
                  }}
                >
                  <div
                    className="icon-wrapper bg-gradient-primary text-white d-flex align-items-center justify-content-center rounded-circle"
                    style={{
                      width: "48px",
                      height: "48px",
                      background: "linear-gradient(135deg, #f6c23e, #e74a3b)",
                      fontSize: "20px",
                    }}
                  >
                    <i className="ti ti-delta"></i>
                  </div>

                  <div className="ms-3">
                    <p
                      className="fw-semibold text-secondary mb-1"
                      style={{ fontSize: "14px" }}
                    >
                      Today's Follow Up
                    </p>
                    <Link
                      to="#"
                      data-bs-toggle="modal"
                      data-bs-target="#follow_up"
                      className="text-decoration-none"
                      style={{ display: "inline-flex", alignItems: "center" }}
                    >
                      <h4 className="text-dark mb-0 me-2">
                        {getDashboardDetails?.total_follow_up_today}
                      </h4>
                      <i className="ti ti-chevron-right text-muted"></i>
                    </Link>
                  </div>
                </div>

                {/* Hover Content */}
                {isHoveredFollowUp && (
                  <div
                    style={{
                      background: "#F8F9FA",
                      padding: "10px",
                      borderRadius: "8px",
                      marginTop: "10px",
                      transition: "opacity 0.3s ease-in-out",
                    }}
                  >
                    <div className="d-flex justify-content-between mb-2">
                      <p className="fw-medium fs-14 mb-0 text-secondary">
                        Pending:
                      </p>
                      <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-bs-target="#follow_up_pending"
                        className="btn btn-white border btn-sm d-inline-flex align-items-center"
                      >
                        <i className="ti ti-clock me-1 text-warning" />
                        {getDashboardDetails?.total_follow_up_pending}
                      </Link>
                    </div>
                    <div className="d-flex justify-content-between">
                      <p className="fw-medium fs-14 mb-0 text-secondary">
                        Total:
                      </p>
                      <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-bs-target="#follow_up_total"
                        className="btn btn-white border btn-sm d-inline-flex align-items-center"
                      >
                        <i className="ti ti-list-details me-1 text-primary" />
                        {getDashboardDetails?.total_follow_up}
                      </Link>
                    </div>
                  </div>
                )}

                <span className="position-absolute top-0 end-0">
                  <img
                    src="assets/img/bg/card-bg-04.png"
                    alt="Img"
                    style={{ width: "50px", opacity: "0.3" }}
                  />
                </span>
              </div>
            </div>

            <div className="col-xl-3 col-md-6">
              <div
                className="position-relative"
                onMouseEnter={() => setisHoveredTodoReminder(true)}
                onMouseLeave={() => setisHoveredTodoReminder(false)}
              >
                <div
                  className="d-flex align-items-center p-3 rounded-4 shadow-sm bg-white hover-shadow-lg transition"
                  style={{
                    border: "1px solid #e0e0e0",
                    cursor: "pointer",
                  }}
                >
                  <div
                    className="icon-wrapper bg-gradient-primary text-white d-flex align-items-center justify-content-center rounded-circle"
                    style={{
                      width: "48px",
                      height: "48px",
                      background: "linear-gradient(135deg, #36b9cc, #1cc88a)",
                      fontSize: "20px",
                    }}
                  >
                    <i className="ti ti-notebook"></i>
                  </div>

                  <div className="ms-3">
                    <p
                      className="fw-semibold text-secondary mb-1"
                      style={{ fontSize: "14px" }}
                    >
                      My Tasks
                    </p>
                    <div
                      className="text-decoration-none"
                      style={{ display: "inline-flex", alignItems: "center" }}
                    >
                      <h4 className="text-dark mb-0 me-2">
                        {getDashboardDetails?.todo_count ||
                          0 + getDashboardDetails?.reminder_count ||
                          0}
                      </h4>
                      <i className="ti ti-chevron-right text-muted"></i>
                    </div>
                  </div>
                </div>

                {/* Hover Content */}
                {isHoveredTodoReminder && (
                  <div
                    style={{
                      background: "#F8F9FA",
                      padding: "10px",
                      borderRadius: "8px",
                      marginTop: "10px",
                      transition: "opacity 0.3s ease-in-out",
                    }}
                  >
                    <div className="d-flex justify-content-between mb-2">
                      <p className="fw-medium fs-14 mb-0 text-secondary">
                        My To-Do:
                      </p>
                      <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-bs-target="#todo_modal"
                        className="btn btn-white border btn-sm d-inline-flex align-items-center"
                      >
                        <i className="ti ti-checklist me-1 text-info" />
                        {getDashboardDetails?.todo_count}
                      </Link>
                    </div>
                    <div className="d-flex justify-content-between">
                      <p className="fw-medium fs-14 mb-0 text-secondary">
                        My Reminders:
                      </p>
                      <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-bs-target="#reminder_modal"
                        className="btn btn-white border btn-sm d-inline-flex align-items-center"
                      >
                        <i className="ti ti-alarm me-1 text-success" />
                        {getDashboardDetails?.reminder_count}
                      </Link>
                    </div>
                  </div>
                )}

                <span className="position-absolute top-0 end-0">
                  <img
                    src="assets/img/bg/card-bg-04.png"
                    alt="Img"
                    style={{ width: "50px", opacity: "0.3" }}
                  />
                </span>
              </div>
            </div>
          </div>
          {/* First Section */}

          {/* Second Section */}
          <div className="row">
            {/* New Leads Heatmap */}
            <div className="col-xl-4 d-flex">
              <div className="card flex-fill">
                <div className="card-header">
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                    <h5>New Deals</h5>
                  </div>
                </div>
                <div className="card-body pb-0">
                  {heatChart?.series?.length > 0 ? (
                    <ReactApexChart
                      id="heat_chart"
                      options={heatChart.options}
                      series={heatChart.series}
                      type="heatmap"
                      height={300}
                    />
                  ) : (
                    <div className="text-center text-muted">
                      No heatmap data available
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="col-xl-4 d-flex flex-column">
              <div className="card flex-fill">
                <div className="card-header">
                  <h5>Deals by Stages</h5>
                </div>

                <div className="card-body">
                  {filteredData.length > 0 ? (
                    <>
                      <ReactApexChart
                        id="donut-chart-source"
                        options={chartData}
                        series={chartData.series ?? []}
                        type="donut"
                        height={185}
                      />
                      <div>
                        <h6 className="mb-3">Lead Pipeline</h6>
                        {visibleLeadsStages.map((lead: any, index: number) => (
                          <div
                            key={index}
                            className="d-flex align-items-center justify-content-between mb-2"
                          >
                            <p className="f-13 mb-0">
                              <i
                                className="ti ti-circle-filled me-1"
                                style={{
                                  color:
                                    chartData.colors?.[
                                      index % chartData.colors.length
                                    ] || "#000",
                                }}
                              />
                              {lead.pipeline_char}
                            </p>
                            <p className="f-13 fw-medium text-gray-9">
                              {((lead.stage_count / total) * 100).toFixed(0)}%
                            </p>
                          </div>
                        ))}

                        {/* View More / View Less Button */}
                        {filteredData.length > 3 && (
                          <div className="text-end mt-2">
                            <button
                              className="btn btn-link p-0 f-13"
                              onClick={() => setShowAllStages(!showAllStages)}
                            >
                              {showAllStages ? "View Less" : "View All"}
                            </button>
                          </div>
                        )}
                      </div>
                    </>
                  ) : (
                    <p className="text-center text-muted">No data available</p>
                  )}
                </div>
              </div>
            </div>

            <div className="col-xl-4 d-flex flex-column">
              <div className="card flex-fill">
                <div className="card-header">
                  <h5>Deals by Source</h5>
                </div>

                <div className="card-body">
                  {leadSources.length > 0 ? (
                    <>
                      <ReactApexChart
                        id="donut-chart-source"
                        options={chartData2}
                        series={chartData2.series ?? []}
                        type="donut"
                        height={185}
                      />
                      <div>
                        <h6 className="mb-3">Deal Sources</h6>
                        {visibleLeads.map((lead: any, index: number) => (
                          <div
                            key={index}
                            className="d-flex align-items-center justify-content-between mb-2"
                          >
                            <p className="f-13 mb-0">
                              <i
                                className="ti ti-circle-filled me-1"
                                style={{
                                  color:
                                    chartData2.colors?.[
                                      index % chartData2.colors.length
                                    ] || "#000",
                                }}
                              />
                              {lead.lead_source_child} ({lead.lead_source})
                            </p>
                            <p className="f-13 fw-medium text-gray-9">
                              {((lead.count / total) * 100).toFixed(0)}%
                            </p>
                          </div>
                        ))}

                        {/* View More / View Less Button */}
                        {leadSources.length > 3 && (
                          <div className="text-end mt-2">
                            <button
                              className="btn btn-link p-0 f-13"
                              onClick={() => setShowAllSources(!showAllSources)}
                            >
                              {showAllSources ? "View Less" : "View All"}
                            </button>
                          </div>
                        )}
                      </div>
                    </>
                  ) : (
                    <p className="text-center text-muted">No data available</p>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* Second Section */}

          {/* Third Section */}
          <div className="row">
            {/* Pipeline Stages */}
            <div className="col-xl-8 d-flex">
              <div className="card flex-fill">
                <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                  <h5>Recent Deals</h5>
                  <div className="d-flex align-items-center">
                    <div>
                      <Link
                        to={routes.leadsList}
                        className="btn btn-white border btn-sm d-inline-flex align-items-center"
                      >
                        View All
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="card-body p-0">
                  <div className="table-responsive">
                    <table className="table table-nowrap dashboard-table mb-0">
                      <thead>
                        <tr>
                          <th>Lead Name</th>
                          <th>Company Name</th>
                          <th>Mobile No</th>
                          <th>Stage</th>
                          <th>Created Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {leadData?.length > 0 ? (
                          leadData?.map((lead: any) => (
                            <tr key={lead.key}>
                              <td>
                                <h6 className="fw-medium">
                                  <Link to="#">
                                    {lead.response["Full Name"]}
                                  </Link>
                                </h6>
                              </td>
                              <td>
                                <div className="d-flex align-items-center file-name-icon">
                                  <Link
                                    to="#"
                                    className="avatar border rounded-circle"
                                  >
                                    <ImageWithBasePath
                                      src={lead.Logo}
                                      className="img-fluid"
                                      alt="img"
                                    />
                                  </Link>
                                  <div className="ms-2">
                                    <h6 className="fw-medium">
                                      <Link to="company-details.html">
                                        {getAbbreviation(lead.company_name)}
                                      </Link>
                                    </h6>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <span
                                  className={`d-inline-flex align-items-center`}
                                >
                                  {lead.Phone}
                                </span>
                              </td>
                              <td>
                                <span
                                  className={`d-inline-flex align-items-center`}
                                >
                                  <i className="ti ti-point-filled me-1" />
                                  {lead.pipeline_char}
                                </span>
                              </td>
                              <td>
                                {" "}
                                {moment(lead.createdAt).format(
                                  "DD-MM-YYYY HH:mm:ss"
                                )}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan={5}
                              className="text-center text-muted py-3"
                            >
                              No leads available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-4 d-flex">
              <div className="card flex-fill">
                <div className="card-header">
                  <div className="d-flex align-items-center justify-content-between flex-wrap">
                    <h5>Recent Activites</h5>
                    <div>
                      <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-bs-target="#recent_activity"
                        className="btn btn-white border btn-sm d-inline-flex align-items-center"
                      >
                        View All
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  {visibleRecentActivity?.length > 0 ? (
                    visibleRecentActivity?.map((list: any, index: number) => (
                      <div
                        key={list.id}
                        className={`d-flex align-items-center justify-content-between ${
                          index !== visibleRecentActivity.length - 1
                            ? "mb-4"
                            : ""
                        }`}
                      >
                        <div className="d-flex">
                          <Link
                            to={routes.leadsList}
                            state={{
                              details: list.lead_id,
                            }}
                            className="d-inline-flex"
                          >
                            <i className="ti ti-point-filled text-primary" />
                            <div className="ms-2">
                              <h6 className="fs-14 fw-medium text-truncate mb-1">
                                {list?.title}
                              </h6>
                              <p className="fs-13">{list?.detail}</p>
                            </div>
                          </Link>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-center text-muted py-4">
                      No data available
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Third Section */}

          {/* Fourth Section */}

          {/* Fourth Section */}

          {/* Fifth Section */}
          <div className="row">
            <div className="col-xl-5 d-flex">
              <div className="card flex-fill">
                <div className="card-header">
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                    <h5>Overview</h5>
                    <div className="row">
                      <div className="col-md-6"></div>
                      <div className="col-md-12">
                        <select
                          className="form-select"
                          onChange={handleFieldChange}
                          disabled={!formFields.length}
                        >
                          <option value="">Select Field</option>
                          {formFields.map((field: any) => (
                            <option key={field.id} value={field.label}>
                              {field.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row">
                    {columnBasedData.length > 0 ? (
                      columnBasedData?.map((data, index) => (
                        <div
                          className="col-md-6 col-lg-4 col-xl-4 mb-4"
                          key={index}
                        >
                          <div className="d-flex align-items-center">
                            <span className="me-2">
                              <i
                                className={`ti ti-point-filled text-primary fs-16`}
                              />
                            </span>

                            <div className="ms-2">
                              <h6 className="fw-medium text-truncate mb-1">
                                {data.name}
                              </h6>
                              <span className="fs-13 text-truncate">
                                Leads : {data.leads}
                              </span>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="text-center text-muted py-4">
                        No data available
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-7 d-flex">
              <div className="card flex-fill">
                <div className="card-header">
                  <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
                    <h5 className="mb-0">Pipeline Stages (Yearly)</h5>
                    <div className="d-flex flex-wrap gap-2">
                      {/* Company Dropdown */}

                      {/* Year Dropdown */}
                      <div className="dropdown">
                        <Link
                          to="#"
                          className="btn btn-white border btn-sm d-inline-flex align-items-center"
                          data-bs-toggle="dropdown"
                        >
                          <i className="ti ti-calendar me-1" />
                          {selectedYear}
                        </Link>
                        <ul className="dropdown-menu dropdown-menu-end p-3">
                          {yearRanges.map((range, index) => (
                            <li key={index}>
                              <Link
                                to="#"
                                className="dropdown-item rounded-1"
                                onClick={() => setSelectedYear(range)}
                              >
                                {range}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="card-body d-flex flex-column justify-content-end"
                  style={{ minHeight: "250px" }}
                >
                  {/* Bar Chart */}
                  {revenueIncome && revenueIncome.series?.length > 0 ? (
                    <ReactApexChart
                      id="revenue-income"
                      options={revenueIncome}
                      series={revenueIncome.series}
                      type="bar"
                      height={230}
                    />
                  ) : (
                    <div className="text-center text-muted mt-auto">
                      No chart data available
                    </div>
                  )}

                  {/* Inline Styles */}
                  <style>
                    {`
                    .stage-name {
                      font-size: 12px;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      display: inline-block;
                      max-width: 100%;
                      vertical-align: middle;
                    }

                    .small-card {
                      transition: box-shadow 0.2s ease;
                    }

                    .small-card:hover {
                      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                    }
                  `}
                  </style>
                </div>
              </div>
            </div>
          </div>
          {/* Fifth Section */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2025 © {company_short_name}</p>
          <p>
            Designed & Developed By{" "}
            <Link to="#" className="text-primary">
              {company_short_name}
            </Link>
          </p>
        </div>
      </div>

      <div className="modal fade" id="follow_up">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Follow Up Reminder</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  updateUI();
                }}
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body pb-0">
                <div className="row">
                  {visibleFollowUpsAll?.length > 0 ? (
                    visibleFollowUpsAll?.map((list: any, index: number) => (
                      <div
                        key={list.followup_id}
                        className={`d-flex align-items-center justify-content-between ${
                          index !== visibleFollowUpsAll?.length - 1
                            ? "mb-4"
                            : ""
                        }`}
                      >
                        <div className="d-flex align-items-center">
                          <Link to="#" className="avatar flex-shrink-0">
                            <ImageWithBasePath
                              src="assets/img/users/user-45.jpg"
                              className="rounded-circle border border-2"
                              alt="img"
                            />
                          </Link>
                          <div className="ms-2">
                            <h6 className="fs-14 fw-medium text-truncate mb-1">
                              <Link to="#">{list.response["Full Name"]}</Link>
                            </h6>
                            <p className="fs-13">
                              {list.response["Mobile No"]}
                            </p>
                          </div>
                        </div>
                        <div className="d-flex align-items-center">
                          <p className="fs-13">
                            {list.follow_up_date?.split("T")[0]}
                          </p>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-center text-muted py-4">
                      No data available
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    updateUI();
                  }}
                >
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="modal fade" id="follow_up_pending">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Pending Follow Up Reminder</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  updateUI();
                }}
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body pb-0">
                <div className="row">
                  {visibleFollowUpsPendingAll?.length > 0 ? (
                    visibleFollowUpsPendingAll?.map(
                      (list: any, index: number) => (
                        <div
                          key={list.followup_id}
                          className={`d-flex align-items-center justify-content-between ${
                            index !== visibleFollowUpsPendingAll?.length - 1
                              ? "mb-4"
                              : ""
                          }`}
                        >
                          <div className="d-flex align-items-center">
                            <Link to="#" className="avatar flex-shrink-0">
                              <ImageWithBasePath
                                src="assets/img/users/user-45.jpg"
                                className="rounded-circle border border-2"
                                alt="img"
                              />
                            </Link>
                            <div className="ms-2">
                              <h6 className="fs-14 fw-medium text-truncate mb-1">
                                <Link to="#">{list.response["Full Name"]}</Link>
                              </h6>
                              <p className="fs-13">
                                {list.response["Mobile No"]}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-center">
                            <p className="fs-13">
                              {list.follow_up_date?.split("T")[0]}
                            </p>
                          </div>
                        </div>
                      )
                    )
                  ) : (
                    <div className="text-center text-muted py-4">
                      No data available
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    updateUI();
                  }}
                >
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="modal fade" id="follow_up_total">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Total Follow Up Reminder</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  updateUI();
                }}
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body pb-0">
                <div className="row">
                  {visibleFollowUpsTotal?.length > 0 ? (
                    visibleFollowUpsTotal?.map((list: any, index: number) => (
                      <div
                        key={list.followup_id}
                        className={`d-flex align-items-center justify-content-between ${
                          index !== visibleFollowUpsTotal?.length - 1
                            ? "mb-4"
                            : ""
                        }`}
                      >
                        <div className="d-flex align-items-center">
                          <Link to="#" className="avatar flex-shrink-0">
                            <ImageWithBasePath
                              src="assets/img/users/user-45.jpg"
                              className="rounded-circle border border-2"
                              alt="img"
                            />
                          </Link>
                          <div className="ms-2">
                            <h6 className="fs-14 fw-medium text-truncate mb-1">
                              <Link to="#">{list.response["Full Name"]}</Link>
                            </h6>
                            <p className="fs-13">
                              {list.response["Mobile No"]}
                            </p>
                          </div>
                        </div>
                        <div className="d-flex align-items-center">
                          <p className="fs-13">
                            {list.follow_up_date?.split("T")[0]}
                          </p>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-center text-muted py-4">
                      No data available
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    updateUI();
                  }}
                >
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="modal fade" id="recent_activity">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">All Activity</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  updateUI();
                }}
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body pb-0">
                <div className="row">
                  {visibleRecentActivityAll?.length > 0 ? (
                    visibleRecentActivityAll?.map(
                      (list: any, index: number) => (
                        <div
                          key={list.id}
                          className={`d-flex align-items-center justify-content-between ${
                            index !== visibleRecentActivityAll.length - 1
                              ? "mb-4"
                              : ""
                          }`}
                        >
                          <div className="d-flex">
                            <Link
                              to={routes.leadsList}
                              state={{
                                details: list.lead_id,
                              }}
                              className="d-inline-flex"
                            >
                              <i className="ti ti-point-filled text-primary" />
                              <div className="ms-2">
                                <h6 className="fs-14 fw-medium text-truncate mb-1">
                                  {list?.title}
                                </h6>
                                <p className="fs-13">{list?.detail}</p>
                              </div>
                            </Link>
                          </div>
                        </div>
                      )
                    )
                  ) : (
                    <div className="text-center text-muted py-4">
                      No data available
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    updateUI();
                  }}
                >
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default CMSDasboard;
